import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Button, Form, Input, Modal } from "antd";
import { FC } from "react";
import { PROJECT_KEYS } from "~/services/project";
import { projectServices } from "~/services/project/project.services";
type Props = {
  open: boolean;
  setOpen: (open: boolean) => void;
};

export const FormProject: FC<Props> = ({ open, setOpen }) => {
  const qc = useQueryClient();

  const mutation = useMutation({
    mutationFn: projectServices.createProject,
    onSuccess: (data) => {
      console.log("Project created successfully:", data);
      qc.invalidateQueries({
        queryKey: [PROJECT_KEYS.PROJECTS],
      });
      setOpen(false);
    },
  });

  return (
    <Modal
      open={open}
      onCancel={() => setOpen(false)}
      onClose={() => setOpen(false)}
      footer={null}
    >
      <Form
        layout="vertical"
        onFinish={(values) => {
          mutation.mutate(values);
        }}
      >
        <Form.Item
          label="Project Name"
          name="name"
          rules={[{ required: true, message: "Please input project name!" }]}
        >
          <Input placeholder="Enter project name" />
        </Form.Item>
        <Form.Item label="Project Description" name="description">
          <Input.TextArea rows={5} placeholder="Enter project description" />
        </Form.Item>

        <Button
          type="primary"
          htmlType="submit"
          className="w-full"
          size="large"
          loading={mutation.isPending}
        >
          Create Project
        </Button>
      </Form>
    </Modal>
  );
};
